import { gql } from "apollo-boost";
import { ChannelTeamFragment } from "../fragments";

export const GET_CHANNEL_TEAMS = gql`
  query getChannelTeams($filter: ChannelTeamFilter!) {
    getChannelTeams(filter: $filter) {
      total
      nodes {
        ...ChannelTeamFragment
      }
    }
  }
  ${ChannelTeamFragment}
`;

export const GET_CHANNEL_TEAM = gql`
    query getChannelTeam($id: ID!) {
        getChannelTeam(id: $id) {
            ...ChannelTeamFragment
        }
    }
    ${ChannelTeamFragment}
`;
